/* eslint-disable react/no-danger,react/no-array-index-key */
/* eslint-disable react/no-unused-prop-types,
no-console,no-useless-constructor */
import React from 'react';
import PropTypes from 'prop-types';
import ReactTable from 'react-table';
import { formatRoute } from 'react-router-named-routes';
import { withTranslation } from 'react-i18next';
import ContentLoader from 'react-content-loader';
// @material-ui/core icons
import Refresh from '@material-ui/icons/Refresh';
import Check from '@material-ui/icons/Check';
import Publish from '@material-ui/icons/CloudUpload';
import Updated from '@material-ui/icons/EditOutlined';
import UnPublish from '@material-ui/icons/CloudDownload';
import ArrowForward from '@material-ui/icons/ArrowForward';
import AddIco from '@material-ui/icons/AddCircle';
import Edit from '@material-ui/icons/Edit';
// material-ui/ core components
import extendedTablesStyle from 'assets/jss/material-dashboard-pro-react/views/extendedTablesStyle';
import Checkbox from '@material-ui/core/Checkbox';
import LinearProgress from '@material-ui/core/LinearProgress/LinearProgress';
import withStyles from '@material-ui/core/styles/withStyles';
// core components
import GridItem from 'components/UI/Grid/GridItem';
import Button from 'components/UI/CustomButtons/Button';
import GridContainer from 'components/UI/Grid/GridContainer';
// our components
import { AD } from 'routes/paths';
import RouterContext from 'helpers/routerContext';
import Paginator from 'components/common/Paginator/PaginatorContainer';
import { LoadingAnimation } from 'components/common/Loading';
import { TableLoader } from 'components/common/TableLoader';
import ReviewQueueInbox from 'components/ReviewQueue/Inbox';
import WithPermission from 'components/User/WithPermission';
import matchedRules, { isFromList } from 'helpers/matchedRulesHelper';
import Badge from 'components/UI/Badge/Badge';
import Snackbar from 'components/UI/Snackbar/Snackbar';
import dateFormat from 'helpers/dateHelper';
import ImageMosaic from 'components/common/ImageMosaic/ImageMosaic';

const hasReviewCategoryRule = ad =>
  ad &&
  Array.isArray(ad.matchedRules) &&
  ad.matchedRules.some(rule => Object.keys(rule)[0] === 'review_category');

const getReviewCategorySuggestion = ad => {
  if (!hasReviewCategoryRule(ad)) {
    return '';
  }
  const reviewCategoryRule = ad.matchedRules.find(
    rule => Object.keys(rule)[0] === 'review_category',
  );
  const payload = reviewCategoryRule.review_category;

  if (payload === null || payload === undefined) {
    return '';
  }
  if (typeof payload === 'string' || typeof payload === 'number') {
    return `${payload}`;
  }
  if (typeof payload === 'object') {
    return `${payload.category_id ||
      payload.subcategoryId ||
      payload.subcategory_id ||
      payload.subcategory ||
      payload.id ||
      ''}`;
  }
  return '';
};

/**
 * @class
 * @extends React.Component
 */
class ReviewQueueList extends React.Component {
  static contextType = RouterContext;

  constructor(props) {
    super(props);
    this.state = {
      selectedItems: [],
    };
  }

  /**
   * @description
   * Select all items.
   *
   * @param {Array} edges - All ads from api.
   * @returns {undefined} No return.
   */
  handleSelectAll = edges => {
    const { selectedItems } = this.state;
    // if all are selected
    if (selectedItems.length === edges.length) {
      this.setState({ selectedItems: [] });
    } else {
      this.setState({ selectedItems: edges.map(item => item.node.id) });
    }
  };

  /**
   * @description
   * Select an item.
   *
   * @param {number} id - Id of selected item.
   * @returns {undefined} No return.
   */
  handleSelectItem = id => {
    const { selectedItems } = this.state;
    // if item is selected
    if (selectedItems.indexOf(id) !== -1) {
      this.setState({
        selectedItems: selectedItems.filter(item => item !== id),
      });
    } else {
      this.setState({ selectedItems: [...selectedItems, id] });
    }
  };

  /**
   * @description
   * Handle publish, unpublish action.
   *
   * @param {string} action - Specific action.
   * @param {Array} items - Items to apply an action.
   * @param {string} categoryId - Suggested category from matched rules.
   */
  handleAction = (action, items, categoryId) => {
    const { adPublish, adUnPublish, adApplyRuleAndPublish } = this.props;
    if (action === 'publish') {
      adPublish(items);
    } else if (action === 'unpublish') {
      adUnPublish(items);
    } else if (action === 'applyRuleAndPublish') {
      adApplyRuleAndPublish(items, categoryId);
    }
    this.setState({ selectedItems: [] });
  };

  /**
   * @description
   * Description of ReactTable columns.
   *
   * @param {Array} edges - All ads from api.
   * @returns {Array} Table columns.
   */
  renderColumns = edges => {
    const { selectedItems } = this.state;
    const { classes, t } = this.props;
    return [
      {
        Header: (
          <Checkbox
            onClick={() => this.handleSelectAll(edges)}
            checked={edges && selectedItems.length === edges.length}
            id="allCheckbox"
            checkedIcon={<Check className={classes.checkedIcon} />}
            icon={<Check className={classes.uncheckedIcon} />}
            classes={{
              checked: classes.checked,
            }}
          />
        ),
        accessor: 'checkbox',
        sortable: false,
        filterable: false,
        maxWidth: 58,
      },
      {
        Header: (
          <span className={classes.headerField}>
            {t('review_queue.headers.title')}
          </span>
        ),
        accessor: 'title',
        sortable: false,
        filterable: false,
        minWidth: 300,
      },
      {
        Header: (
          <div className={classes.headerField}>
            {t('review_queue.headers.ipScore')}
          </div>
        ),
        accessor: 'ipScore',
        sortable: false,
        filterable: false,
        minWidth: 150,
      },
      {
        Header: (
          <span className={classes.headerField}>
            {t('review_queue.headers.rules')}
          </span>
        ),
        accessor: 'rules',
        sortable: false,
        filterable: false,
        minWidth: 300,
      },
      {
        Header: (
          <span className={classes.headerField}>
            {t('review_queue.headers.unpublish')}
          </span>
        ),
        accessor: 'unpublish',
        sortable: false,
        filterable: false,
        maxWidth: 150,
      },
      {
        Header: (
          <span className={classes.headerField} style={{ textAlign: 'left' }}>
            <p>{t('review_queue.headers.publish')}</p>
          </span>
        ),
        accessor: 'publish',
        sortable: false,
        filterable: false,
        minWidth: 280,
      },
      {
        expander: true,
        show: false,
      },
    ];
  };

  /**
   * @description
   * Map the data from api to ReactTable rows.
   *
   * @param {Array} edges - All ads from api.
   * @returns {Array} Table rows.
   */
  renderRows = edges => {
    const { selectedItems } = this.state;
    const { classes, t } = this.props;
    const history = this.context;
    return edges.map(({ node }) => ({
      id: node.id,
      checkbox: (
        <Checkbox
          onClick={() => {
            this.handleSelectItem(node.id);
          }}
          checked={selectedItems.indexOf(node.id) !== -1}
          checkedIcon={<Check className={classes.checkedIcon} />}
          icon={<Check className={classes.uncheckedIcon} />}
          classes={{
            checked: classes.checked,
          }}
        />
      ),
      title: (
        <WithPermission
          alt={
            <div
              id={`ad-title-${node.id}`}
              className={classes.adTitleContainer}
            >
              {node.readyImages && (
                <ImageMosaic
                  images={node.readyImages.map(({ id, urls }) => ({
                    id,
                    ...urls,
                  }))}
                />
              )}
              <ul className={classes.adCatBread} style={{ color: '#217db2' }}>
                <li data-cy="adCategory" style={{ padding: '0', margin: 0 }}>
                  {node.subcategory.parentCategory.title}
                </li>
                <li className={classes.adIconBread}>
                  <ArrowForward color="disabled" />
                </li>
                <li data-cy="adSubcategory" style={{ padding: '0', margin: 0 }}>
                  {node.subcategory.title}
                </li>
              </ul>
              <div style={{ display: 'flex', flexWrap: 'wrap', width: '100%' }}>
                {node.isAuto && <small className={classes.adAuto}>AUTO</small>}
                <div className={classes.idAndDate}>
                  <p>
                    <b>ID: {node.id}</b>
                  </p>
                  <p className={classes.modificationDate}>
                    <Updated />
                    {node.updatedOn && dateFormat(node.updatedOn, t)}
                  </p>
                </div>

                <p className={classes.adTitle}>{node.title}</p>
              </div>
              <div style={{ display: 'flex', flexWrap: 'wrap', width: '100%' }}>
                {node.isAuto && <small className={classes.adAuto}>AUTO</small>}
                <div className={classes.idAndDate}>
                  <p>
                    <b>ID: {node.id}</b>
                  </p>
                  <p className={classes.modificationDate}>
                    <Updated /> {node.updateCount} •
                    <span style={{ marginLeft: 4 }}>
                      {node.updatedOn && dateFormat(node.updatedOn, t)}
                    </span>
                  </p>
                </div>

                <p className={classes.adTitle}>{node.title}</p>
              </div>
            </div>
          }
          allowPermissions={['view_ad']}
        >
          <div
            style={{ padding: '8px 0' }}
            id={`ad-title-${node.id}`}
            data-cy="adTitle"
          >
            {node.readyImages && (
              <ImageMosaic
                images={node.readyImages.map(({ id, urls }) => ({
                  id,
                  ...urls,
                }))}
              />
            )}
            <div style={{ display: 'flex', flexWrap: 'wrap', width: '100%' }}>
              <div className={classes.idAndDate}>
                <WithPermission
                  allowPermissions={[
                    'view_autopaidad',
                    'view_ownership_autopaidad',
                  ]}
                >
                  {node.isAuto && (
                    <small className={classes.adAuto}>AUTO</small>
                  )}
                </WithPermission>
                <p>
                  <b data-cy={node.id}>ID: {node.id}</b>
                  {node.flagCount > 0 && (
                    <span style={{ marginLeft: 8 }}>
                      <Badge color="danger">{node.flagCount}</Badge>
                    </span>
                  )}
                </p>
                <p className={classes.modificationDate}>
                  <Updated /> {node.updateCount} •
                  <span style={{ marginLeft: 4 }}>
                    {node.updatedOn && dateFormat(node.updatedOn, t)}
                  </span>
                </p>
              </div>

              <ul className={classes.adCatBread} style={{ color: '#217db2' }}>
                <li data-cy="adCategory" style={{ padding: '0', margin: 0 }}>
                  {node.subcategory.parentCategory.title}
                </li>
                <li className={classes.adIconBread}>
                  <ArrowForward color="disabled" />
                </li>
                <li data-cy="adSubcategory" style={{ padding: '0', margin: 0 }}>
                  {node.subcategory.title}
                </li>
              </ul>

              <a
                color="primary"
                className={['read', classes.adBtns, classes.titleBtn].join(' ')}
                href={formatRoute(AD.DETAILS, { id: node.id })}
                onClick={e => {
                  e.preventDefault();
                  history.push(formatRoute(AD.DETAILS, { id: node.id }));
                }}
              >
                {node.title}
              </a>
            </div>
          </div>
        </WithPermission>
      ),
      ipScore: (
        <React.Fragment>
          <div className={[classes.botScore, classes.idAndDate].join(' ')}>
            <AddIco />
            <a
              className={['read', classes.adBtns, classes.scoreLink].join(' ')}
              href={`${AD.LIST}?sameOwnerAds=${node.id}`}
              rel="noopener noreferrer"
              target="_blank"
              style={{ float: 'left' }}
            >
              {node.botScoreInsert !== null
                ? node.botScoreInsert
                : t('common.unknown')}
            </a>
            <span>{node.countryInsert || t('common.unknown')}</span>
            <span style={{ marginLeft: '8px' }}>
              {node.ipInsert || t('common.unknown')}
            </span>
          </div>
          {node.updateCount > 0 && (
            <React.Fragment>
              <div className={[classes.botScore, classes.idAndDate].join(' ')}>
                <Edit />
                <a
                  className={['read', classes.adBtns, classes.scoreLink].join(
                    ' ',
                  )}
                  href={`${AD.LIST}?sameOwnerAds=${node.id}`}
                  rel="noopener noreferrer"
                  target="_blank"
                  style={{ float: 'left' }}
                >
                  {node.botScoreUpdate !== null
                    ? node.botScoreUpdate
                    : t('common.unknown')}
                </a>
                <span>{node.countryUpdate || t('common.unknown')}</span>
                <span style={{ marginLeft: '8px' }}>
                  {node.ipUpdate || t('common.unknown')}
                </span>
              </div>
            </React.Fragment>
          )}
        </React.Fragment>
      ),
      rules:
        node.matchedRules &&
        Array.isArray(node.matchedRules) &&
        node.matchedRules.map((matchedRule, key) => {
          if (!isFromList(matchedRule)) {
            return matchedRules(node, classes, t, matchedRule);
          }
          return (
            <div
              key={`mr-list-${node.id}-${key}`}
              className={classes.matchedRule}
              dangerouslySetInnerHTML={{
                __html: matchedRules(node, classes, t, matchedRule),
              }}
            />
          );
        }),
      unpublish: (
        <WithPermission allowPermissions={['publish_ad']}>
          <Button
            id={`unpublish-ad-${node.id}`}
            color="danger"
            onClick={() => this.handleAction('unpublish', [node.id])}
          >
            {t('common.unpublish')}
          </Button>
        </WithPermission>
      ),
      publish: (
        <WithPermission allowPermissions={['publish_ad']}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <Button
              id={`publish-ad-${node.id}`}
              color="success"
              onClick={() => this.handleAction('publish', [node.id])}
            >
              {t('common.publish')}
            </Button>
            {hasReviewCategoryRule(node) && (
              <Button
                id={`apply-rule-publish-ad-${node.id}`}
                color="info"
                style={{ marginLeft: 8 }}
                onClick={() =>
                  this.handleAction(
                    'applyRuleAndPublish',
                    [node.id],
                    getReviewCategorySuggestion(node),
                  )
                }
              >
                {t('review_queue.buttons.change_category')}
              </Button>
            )}
          </div>
        </WithPermission>
      ),
    }));
  };

  /**
   * @description
   * Map Loading index Rows with itemProcessing.
   *
   * @param {Object} itemProcessing - Ids of items that is processing.
   * @param {Object} edges - Edges of connection data.
   */
  mapLoadingRows = (itemProcessing, edges) => {
    const loadingRows = {};
    edges.forEach((value, index) => {
      if (itemProcessing.includes(value.node.id)) {
        loadingRows[index] = true;
      }
    });
    return loadingRows;
  };

  /**
   * @description
   * Render Filter, Paginator and ReactTable components.
   * @returns {*} Paginator and ReactTable components.
   */
  render() {
    const {
      data,
      dataCountInbox,
      loading,
      fullLoading,
      changeInbox,
      changeNumberOfRows,
      changePage,
      numberOfRowsSelected,
      paginationDirection,
      currentInbox,
      classes,
      refresh,
      itemProcessing,
      t,
      failedIds,
      showNotification,
      closeNotification,
    } = this.props;
    const { selectedItems } = this.state;
    const edges = loading || data === undefined ? [] : data.ads.edges;
    const rows = this.renderRows(edges);
    const cols = this.renderColumns(edges);
    const loadingRows = this.mapLoadingRows(itemProcessing, edges);
    return (
      <React.Fragment>
        <Snackbar
          place="tc"
          color="danger"
          message={t(`common.failed_bulk_action`, {
            count: failedIds.length,
          })}
          open={showNotification}
          closeNotification={closeNotification}
          close
        />
        <div className={classes.pageContainer}>
          <GridContainer justify="space-between" alignItems="center">
            <GridItem>
              <h3 className={classes.title}>{t('review_queue.title')}</h3>
            </GridItem>
            <GridItem>
              <Button
                color="primary"
                simple
                className={classes.showFilters}
                onClick={() => refresh()}
                id="refresh"
                key="refresh"
              >
                <Refresh />
                {t('ad.filters.update')}
              </Button>
            </GridItem>
          </GridContainer>

          <div className={classes.contentContainer}>
            <div
              className={[classes.loadingLineContainer, classes.topLine].join(
                ' ',
              )}
            >
              {' '}
              {fullLoading && (
                <LinearProgress
                  classes={{
                    barColorPrimary: classes.loadingLine,
                  }}
                />
              )}
            </div>
            <GridContainer>
              <GridItem
                className={[
                  classes.groupActions,
                  classes.loteActionsAnimation,
                  selectedItems.length > 0
                    ? classes.showLote
                    : classes.hideLote,
                ].join(' ')}
                xs={12}
              >
                <WithPermission allowPermissions={['publish_ad']}>
                  <Button
                    color="danger"
                    simple
                    size="lg"
                    onClick={() =>
                      this.handleAction('unpublish', selectedItems)
                    }
                    id="unpublishAd"
                  >
                    <UnPublish />
                    {t('common.unpublish')}
                  </Button>
                  <Button
                    color="success"
                    simple
                    size="lg"
                    onClick={() => this.handleAction('publish', selectedItems)}
                    id="publishAd"
                  >
                    <Publish />
                    {t('common.publish')}
                  </Button>
                </WithPermission>
              </GridItem>
              <GridItem
                className={[
                  classes.z2,
                  classes.loteActionsAnimation,
                  selectedItems.length > 0
                    ? classes.hideLote
                    : classes.showLote,
                ].join(' ')}
                xs={12}
              >
                <GridContainer justify="flex-end" alignItems="center">
                  <GridItem xs={12} sm={12} md={6} lg={8}>
                    <ReviewQueueInbox
                      data={dataCountInbox}
                      changeInbox={changeInbox}
                      currentInbox={currentInbox}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={8} md={6} lg={4}>
                    {!fullLoading ? (
                      <Paginator
                        pageInfo={data.ads.pageInfo}
                        changePage={changePage}
                        changeNumberOfRows={changeNumberOfRows}
                        paginationDirection={paginationDirection}
                        numberOfRowsSelected={numberOfRowsSelected}
                      />
                    ) : (
                      <ContentLoader height={67} width={327} speed={2}>
                        <path
                          // eslint-disable-next-line max-len
                          d="M199,16 L304,16 C307.313708,16 310,18.6862915 310,22 L310,46 C310,49.3137085 307.313708,52 304,52 L199,52 C195.686292,52 193,49.3137085 193,46 L193,22 C193,18.6862915 195.686292,16 199,16 Z M25.9861352,27.0121317 L70.0138648,27.0121317 C74.4244855,27.0121317 78,30.5876462 78,34.9982669 C78,39.4088876 74.4244855,42.9844021 70.0138648,42.9844021 L25.9861352,42.9844021 C21.5755145,42.9844021 18,39.4088876 18,34.9982669 C18,30.5876462 21.5755145,27.0121317 25.9861352,27.0121317 Z M103.986135,27.0121317 L148.013865,27.0121317 C152.424485,27.0121317 156,30.5876462 156,34.9982669 C156,39.4088876 152.424485,42.9844021 148.013865,42.9844021 L103.986135,42.9844021 C99.5755145,42.9844021 96,39.4088876 96,34.9982669 C96,30.5876462 99.5755145,27.0121317 103.986135,27.0121317 Z"
                          fill="#D8D8D8"
                        />
                      </ContentLoader>
                    )}
                  </GridItem>
                </GridContainer>
              </GridItem>
              <GridItem xs={12} className={classes.z3}>
                <GridContainer>
                  <GridItem xs={12}>
                    {loading ? (
                      <TableLoader />
                    ) : (
                      <ReactTable
                        data={rows}
                        filterable
                        columns={cols}
                        loading={loading}
                        pageSize={
                          edges.length < numberOfRowsSelected
                            ? edges.length
                            : numberOfRowsSelected
                        }
                        showPagination={false}
                        className={['-striped -highlight', classes.tbl].join(
                          ' ',
                        )}
                        expanded={loadingRows}
                        SubComponent={() => (
                          <div className={classes.loading}>
                            <LoadingAnimation />
                          </div>
                        )}
                        getTrProps={(state, rowInfo) => ({
                          style: {
                            borderLeft:
                              rowInfo &&
                              failedIds.indexOf(rowInfo.original.id) !== -1
                                ? '4px solid red'
                                : '',
                          },
                        })}
                        noDataText={t('common.no_data')}
                        minRows={8}
                      />
                    )}
                  </GridItem>
                </GridContainer>
                <GridContainer justify="flex-end">
                  <GridItem xs={12} sm={4}>
                    {!fullLoading ? (
                      <Paginator
                        pageInfo={data.ads.pageInfo}
                        changePage={changePage}
                        changeNumberOfRows={changeNumberOfRows}
                        paginationDirection={paginationDirection}
                        numberOfRowsSelected={numberOfRowsSelected}
                      />
                    ) : (
                      <ContentLoader height={67} width={327} speed={2}>
                        <path
                          // eslint-disable-next-line max-len
                          d="M199,16 L304,16 C307.313708,16 310,18.6862915 310,22 L310,46 C310,49.3137085 307.313708,52 304,52 L199,52 C195.686292,52 193,49.3137085 193,46 L193,22 C193,18.6862915 195.686292,16 199,16 Z M25.9861352,27.0121317 L70.0138648,27.0121317 C74.4244855,27.0121317 78,30.5876462 78,34.9982669 C78,39.4088876 74.4244855,42.9844021 70.0138648,42.9844021 L25.9861352,42.9844021 C21.5755145,42.9844021 18,39.4088876 18,34.9982669 C18,30.5876462 21.5755145,27.0121317 25.9861352,27.0121317 Z M103.986135,27.0121317 L148.013865,27.0121317 C152.424485,27.0121317 156,30.5876462 156,34.9982669 C156,39.4088876 152.424485,42.9844021 148.013865,42.9844021 L103.986135,42.9844021 C99.5755145,42.9844021 96,39.4088876 96,34.9982669 C96,30.5876462 99.5755145,27.0121317 103.986135,27.0121317 Z"
                          fill="#D8D8D8"
                        />
                      </ContentLoader>
                    )}
                  </GridItem>
                </GridContainer>
              </GridItem>
            </GridContainer>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

/**
 * ReviewQueueList PropTypes
 * @param classes - prop styles received from withStyles
 * @param data - prop ads query's results
 * @param dataCountInbox - prop count inbox query's results
 * @param itemProcessing - id of items that is processing
 * @param numberOfRowsSelected - prop current number of rows selected
 * @param loading - prop ads query or mutations status
 * @param fullLoading - prop ads loading data from query
 * @param currentInbox - prop to know what is the current inbox tab selected
 * @param t - prop from HOC with string translations
 * @param failedIds - id of items that was failed after bulk action
 * @param showNotification - prop to know if notification will be showed or not
 * @callback adPublish - callback to publish elements
 * @callback adUnPublish - callback to unpublish elements
 * @callback changeInbox - callback to chage inbox tab
 * @callback changePage - prop pass to Paginator
 * @callback refresh - callback to refresh page
 * @callback changeNumberOfRows - prop pass to Paginator
 * @callback closeNotification - callback to close notification
 */

ReviewQueueList.propTypes = {
  classes: PropTypes.instanceOf(Object).isRequired,
  data: PropTypes.shape({}).isRequired,
  dataCountInbox: PropTypes.shape({}).isRequired,
  itemProcessing: PropTypes.instanceOf(Array).isRequired,
  numberOfRowsSelected: PropTypes.number.isRequired,
  // eslint-disable-next-line react/require-default-props
  paginationDirection: PropTypes.string,
  adPublish: PropTypes.func.isRequired,
  adUnPublish: PropTypes.func.isRequired,
  adApplyRuleAndPublish: PropTypes.func.isRequired,
  refresh: PropTypes.func.isRequired,
  changePage: PropTypes.func.isRequired,
  changeInbox: PropTypes.func.isRequired,
  changeNumberOfRows: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  fullLoading: PropTypes.bool.isRequired,
  currentInbox: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired,
  failedIds: PropTypes.instanceOf(Array).isRequired,
  showNotification: PropTypes.bool.isRequired,
  closeNotification: PropTypes.func.isRequired,
};

// to fix: The withStyles HOC set contextTypes to a children component
// and it have problem with contextType assigned to PermissionList component
// This is a small hack, with intermediary Component to resolved it temporally
const AdWrapper = props => <ReviewQueueList {...props} />;

export default withTranslation()(withStyles(extendedTablesStyle)(AdWrapper));
